import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const WhatsAppForms = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [forms, setForms] = useState([]); 

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const handleSyncData = () => {
    console.log("Syncing data...");
  };

  return (
    <div
      className="container-fluid mt-4 p-4 border rounded"
      style={{ maxHeight: "85vh", overflow: "auto" }}
    >


      <div className="d-flex align-items-center justify-content-between row border-bottom ">
        <div className="mb-3 d-flex align-items-center col-md-8">

          <div className="me-3">
            <h2 className="m-0">
              <i className="bi bi-stars"></i>
            </h2>
          </div>

          <div className="header-text-content">
            <h6 className="mb-0">WhatsApp Forms</h6>
            <p className="text-muted">
              Transform leadgen via interactive WhatsApp Forms
            </p>
          </div>
        </div>
      </div>


      <div className="border rounded p-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <input
          type="text"
          className="form-control w-25"
          placeholder="🔍 Search by name"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <div>
          <button
            className="btn btn-outline-secondary me-2"
            onClick={handleSyncData}
          >
            <i className="bi bi-arrow-repeat me-1"></i> Sync Data
          </button>
          <button className="btn btn-outline-primary">
            <i className="bi bi-funnel-fill me-1"></i> Filter by Status
          </button>
        </div>
      </div>


      <div className="card p-3 w-100">
        <h5 className="mb-3">WhatsApp Forms Details</h5>
        <table className="table ">
          <thead className="table-light">
            <tr>
              <th>Form Name</th>
              <th>Form ID</th>
              <th>Status</th>
              <th>Responses</th>
            </tr>
          </thead>
          <tbody>
            {forms.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center text-muted py-4">
                  <div className="d-flex flex-column align-items-center">
                    <i className="bi bi-plus-circle fs-1 text-secondary"></i>
                    <p className="mt-2">No result found</p>
                  </div>
                </td>
              </tr>
            ) : (
              forms.map((form, index) => (
                <tr key={index}>
                  <td>{form.name}</td>
                  <td>{form.id}</td>
                  <td>{form.status}</td>
                  <td>{form.responses}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
    </div>
  );
};

export default WhatsAppForms;
